export default __webpack_public_path__ + "static/media/zipcode filter.96de1e44.png";